angular
  .module("pitch.app")

  .filter("sanitizeId", [
    function() {
      return function(input) {
        if (input === undefined) {
          return;
        }
        return input.toLowerCase().replace(/^[^a-z]+|[^\w:.-]+/gi, "");
      };
    }
  ]);



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/filters/sanitizeId.js